module.exports = __webpack_public_path__ + "static/media/JoanaSeixas.e0f7c3ae.mp4";